/* eslint no-magic-numbers: "off"*/

import ScrollMagic from 'scrollmagic';

const LARGE = 1279;

const controller = new ScrollMagic.Controller();

const fadeInContent = ( el ) => {
  let $el = $( el );
  new ScrollMagic.Scene({
    triggerElement: $el[0],
    offset:         200,
    triggerHook:    0.9,
    reverse:        false,
  }).addTo( controller ).on( 'start', function() {
    setTimeout( () => {
      $el.find( '.image-wrapper' ).addClass( 'zoom-in' );
      $el.find( '.top-content' ).removeClass( 'hide-content' );
      setTimeout( () => {
        $el.find( '.bottom-content' ).removeClass( 'hide-content' );
      }, 300 );
    }, 450 );
  });
};

$( window ).on( 'load', function() {
  $( '.module--text-product' ).each( function( index, el ) {
    if ( window.innerWidth >= LARGE ) {
      fadeInContent( el );
    }
  });
});
